import { ContentBlockAttribute, Maybe } from 'interfaces/bumble-seasonal-content-hub-microsite-cms';
import * as React from 'react';

const AtrributesBlock: React.FC<{ attributes: Maybe<ContentBlockAttribute>[] }> = ({
    attributes,
}) => (
    <ul>
        {attributes &&
            attributes.map((attr, i) =>
                attr ? (
                    <li key={i}>
                        <strong>{attr.name}</strong>: {attr.value || 'null'}
                    </li>
                ) : null
            )}
    </ul>
);

export default AtrributesBlock;
